import axios from 'axios';
import { Translation } from '@deaf-bible-society-2-0/deafbible-metadata-utils';
import { RecordItem } from '../../components/MainVideoPlayer/BBBResourcesLayouts/types';

export const getTranslation = async (
  code: string | undefined
): Promise<Translation | undefined> => {
  try {
    if (code !== undefined) {
      const { data } = await axios.get(
        `${process.env.REACT_APP_NEW_API}/translations/${code.toLowerCase()}`
      );

      return data;
    }
  } catch (err) {
    return undefined;
  }
  return undefined;
};

export const getBBBResources = async (bbbId: string): Promise<RecordItem[] | []> => {
  try {
    if (bbbId !== undefined) {
      const { data } = await axios.get(
        `${process.env.REACT_APP_DEAFBIBLESOCIETY_API_V2}/v1/deafbible/bbb-resources/${bbbId}`
      );
      return data.data;
    }
  } catch (err) {
    return [];
  }
  return [];
};
